import { Config } from '@cian/config';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { prepareApplication } from '../core/browser/utils/app';
import { Application } from '../shared';
import { IApplicationState } from '../shared/types/redux';

export const runApp = (config: Config) => {
  prepareApplication({ config }).then(({ logger }) => {
    const projectName = config.get<string>('projectName');

    const rootElement = document.getElementById(projectName as string);

    if (!rootElement) {
      throw new Error(`Unable to find element #${projectName}`);
    }

    const initialState = config.get<IApplicationState>('initialState') as IApplicationState;

    ReactDOM.hydrate(
      <Application config={config} initialState={initialState} logger={logger} />,
      rootElement,
      () => {},
    );
  });
};
